module.exports = __webpack_public_path__ + "static/media/no-image-available.ca2ca94f.png";